module.exports = __webpack_public_path__ + "img/交互设计.afba61ec.svg";